/*
 * Copyright (c) Worldline 2023.
 */

import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Injectable({
    providedIn: 'root'
})
export class LangKeyService {

    constructor(private translate: TranslateService) {
    }

    public langKey = this.translate.currentLang


    private availableLocales = ['fr', 'en', 'de', 'es', 'nl'];

    private defaultLocale = 'en';

    // the default locale is get during the "getSession" call
    // inside the configuration DTO , the default value is 'en'
    setDefaultLocale(locale: any) {
        console.debug('Change default language to :', locale);
        if (this.availableLocales.indexOf(locale) !== -1) {
            this.defaultLocale = locale;
        }
        console.debug('Default language is now :', this.defaultLocale);
    }

    setLocale(newVal: any) {
        if (newVal) {
            if (this.availableLocales.indexOf(newVal) === -1) {
                //fallback on default one
                newVal = this.defaultLocale;
            }

            console.debug('Change language to :', newVal);
            this.langKey = newVal;
            if (newVal) { // if locale is unknown and default is not set, no need to update
                this.translate.use(newVal);
            }
        } else {
            console.debug('langKey is undefined');
        }
    }
}
